import { GeographyModel } from "../models/GeographyModel";
import API, { client } from "./API";

const GeographyService = {
  async getAllGeographies() {
    const response = await API().get("ProjectGeography", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularGeography(geography_id: number) {
    const response = await API().get("Geography");
    return response.data.filter(
      (cur_geography: GeographyModel) =>
        cur_geography.geographyId === geography_id
    )[0];
  },
  async createGeography(data: GeographyModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `ProjectGeography/${id}` : "ProjectGeography",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default GeographyService;
